export default __webpack_public_path__ + "static/media/reaction-03.cb860a81.svg";